/**
 * TeamSystem Impact - Pending Consolidations Hook
 *
 * Conta i gruppi per-country che il validatore corrente deve (ri)consolidare
 * per l'anno di lavoro. Usa l'endpoint /consolidation/pending-count, la stessa
 * fonte del badge "X gruppi da consolidare" nella pagina Validazione.
 * Se la fetch fallisce ritorna 0 (la dashboard non crasha).
 */

import { useState, useEffect } from 'react';
import { apiClient } from '../../../api/client';
import { useWorkingYear } from '../../../store/workingYearStore';

export function usePendingConsolidations(): number {
  const { year } = useWorkingYear();
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;

    apiClient
      .get<{ success: boolean; data: { count: number } }>(
        `/data-capture/consolidation/pending-count?assessmentYear=${year}`
      )
      .then((res) => {
        if (!cancelled && res.data?.data) {
          setCount(res.data.data.count || 0);
        }
      })
      .catch(() => {
        // Non crashare — fallback 0
      });

    return () => {
      cancelled = true;
    };
  }, [year]);

  return count;
}
